module.exports = __webpack_public_path__ + "img/avatar_ico15.103aac8f.jpg";